module.exports = __webpack_public_path__ + "img/GR026N.39cd8801.png";